import { useEffect } from 'react';
import type { FieldType, FormField } from '../contexts';
import { useFormDispatch } from '../contexts';
import { fieldValidators } from '../fields';

export const USED_URL_FIELDS: (FieldType | undefined)[] = [
  'shortText',
  'longText',
  'email',
  'URL',
  'phone',
  'number',
  'hidden',
  'numberScale'
];

export interface UrlParamProps {
  id: string;
  name: string;
  fieldID: string;
}

export function useUrlParams(urlParams: UrlParamProps[], fields: FormField[]) {
  const dispatch = useFormDispatch();

  useEffect(() => {
    const gettedUrlParams: { [index: string]: string } = {};
    const values = window.location.search
      .substring(window.location.search.indexOf('?') + 1)
      .split('&');

    if (values) {
      values.forEach((value) => {
        const [fieldName, fieldValue] = value.split('=');
        gettedUrlParams[decodeURIComponent(fieldName)] =
          decodeURIComponent(fieldValue);
      });
    }

    urlParams
      ?.filter(({ fieldID }) => {
        const type = getFieldType(fields, fieldID);
        return USED_URL_FIELDS.includes(type);
      })
      .forEach((param) => {
        const { name, fieldID } = param;

        if (Object.keys(gettedUrlParams).includes(name)) {
          const value = gettedUrlParams[name];
          const type = getFieldType(fields, fieldID);

          if (type) {
            const validator =
              fieldValidators[type as keyof typeof fieldValidators];
            const valid = validator ? validator(value) : true;

            dispatch({
              type: 'changeField',
              field: {
                id: fieldID,
                value,
                valid,
                type
              }
            });
          }
        }
      });
  }, []);
}

function getFieldType(fields: FormField[], fieldID: string) {
  return fields.find(({ id }) => id === fieldID)?.type;
}
